import { Directive, HostListener } from '@angular/core';

@Directive({
	selector: '[appNumbersInput]',
})
export class NumbersInputDirective {
	constructor() {}

	@HostListener('keydown', ['$event']) onKeyDown(event) {
		let e = <KeyboardEvent>event;
		if ((e.keyCode == 86 && e.ctrlKey) || e.metaKey) {
			setTimeout(() => {
				if (event.target.value != event.target.value.replace(/[^0-9]/g, '')) {
					event.target.value = event.target.value.replace(/[^0-9]/g, '');
				}
				return;
			}, 50);
		}
		if (
			[46, 8, 9, 27, 13, 110].indexOf(e.keyCode) !== -1 ||
			(e.keyCode == 65 && e.ctrlKey) ||
			e.metaKey ||
			(e.keyCode == 67 && e.ctrlKey) ||
			e.metaKey ||
			(e.keyCode == 88 && e.ctrlKey) ||
			e.metaKey ||
			(e.keyCode >= 35 && e.keyCode <= 39)
		) {
			return;
		}
		if ((e.shiftKey || e.keyCode < 48 || e.keyCode > 57) && (e.keyCode < 96 || e.keyCode > 105)) {
			e.preventDefault();
		}
	}
}
